"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

require("./Radio.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Radio
var Radio = function Radio(_ref) {
  var options = _ref.options,
      defaultIndex = _ref.defaultIndex,
      onChange = _ref.onChange,
      optContainerClassName = _ref.optContainerClassName,
      optClassName = _ref.optClassName,
      optLabelClassName = _ref.optLabelClassName;
  // Handle default selected option
  var defaultSelectedIndex = defaultIndex ? defaultIndex : 0; // Handle selected option

  var _useState = (0, _react.useState)(defaultSelectedIndex),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  var handleOnClick = function handleOnClick(e, index) {
    e.preventDefault();
    setSelectedIndex(index);

    if (typeof onChange === 'function') {
      onChange(index);
    }
  };

  var radioContainerClassName = optContainerClassName ? "RadioContainer ".concat(optContainerClassName) : 'RadioContainer';
  var labelClassName = optLabelClassName ? "radio__label ".concat(optLabelClassName) : 'radio__label';
  var radioClassName = optClassName ? "Radio ".concat(optClassName) : 'Radio';
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: radioContainerClassName
  }, options.map(function (option, index) {
    var radioKey = radioClassName ? "radio-".concat(index, "-").concat(radioClassName) : "radio-".concat(index);
    return /*#__PURE__*/_react.default.createElement("label", {
      className: radioClassName,
      key: radioKey
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "radio__input"
    }, index === selectedIndex && /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: "radio",
      checked: true,
      onChange: function onChange(e) {
        return handleOnClick(e, index);
      }
    }), index !== selectedIndex && /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: "radio",
      onChange: function onChange(e) {
        return handleOnClick(e, index);
      }
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "radio__control"
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: labelClassName
    }, option));
  }));
};

exports.Radio = Radio;
Radio.defaultProps = {
  optContainerClassName: null,
  optLabelClassName: null,
  optClassName: null
};